import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  setItem(key: string) {
    const userState = localStorage.getItem("userState");
    const username = userState ? JSON.parse(userState).username : undefined;
    const empMessages = JSON.parse(localStorage.getItem('messages') || '{}');
    empMessages[username] =  empMessages[username] ? empMessages[username] : {};
    empMessages[username][key] = true;
    localStorage.setItem('messages', JSON.stringify(empMessages));
  }

  getItem(key: string):boolean{
      const userState = localStorage.getItem("userState");
    const username = userState ? JSON.parse(userState).username : undefined;    
    const empMessages = JSON.parse(localStorage.getItem('messages') || '{}');
    if (empMessages[username] && empMessages[username][key]) {
      return true;
    } else {
      return false;
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

}
